// extracted by mini-css-extract-plugin
export var carrierIcon = "_wa-0";
export var carrierLogo = "_wa-1";
export var detailsSection = "_wa-2";